import { render } from "./ExpensesSettingsSection.vue?vue&type=template&id=79d9a7c8"
import script from "./ExpensesSettingsSection.vue?vue&type=script&lang=js"
export * from "./ExpensesSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__